<template>
  <div v-if="districtsFound">
    <div v-if="areas.paid_districts.length" class="flex flex-wrap text-sm">
      <span class="m-2 p-1"> {{ !areas.free_sectors.length && !areas.free_districts.length ? 'Districts Covered:' : 'Paid Districts:'}}</span>
      <span class="m-2 p-1 bg-grey-lighter" v-for="(district, i) in areas.paid_districts" :key="i">
        {{ district }}
      </span>
    </div>
    <div v-if="areas.paid_sectors.length" class="flex flex-wrap text-sm">
      <span class="m-2 p-1"> {{ !areas.free_sectors.length && !areas.free_districts.length ? 'Sectors Covered:' : 'Paid Sectors:'}}</span>
      <span class="m-2 p-1 bg-grey-lighter" v-for="(sector, i) in areas.paid_sectors" :key="i">
        {{ sector }}
      </span>
    </div>
    <div v-if="areas.free_districts.length" class="flex flex-wrap text-sm">
      <span class="m-2 p-1">Free Districts: </span>
      <span class="m-2 p-1 bg-grey-lighter" v-for="(district, i) in areas.free_districts" :key="i">
        {{ district }}
      </span>
    </div>
    <div v-if="areas.free_sectors.length" class="flex flex-wrap text-sm">
      <span class="m-2 p-1">Free Sector: </span>
      <span class="m-2 p-1 bg-grey-lighter" v-for="(sector, i) in areas.free_sectors" :key="i">
        {{ sector }}
      </span>
    </div>
  </div>
</template>

<script>
import api from '@/http'
import { mapState } from 'vuex'

export default {
  name: 'post-codes-covered',
  data () {
    return {
      areas: {}
    }
  },
  computed: {
    ...mapState(['selectedOffice']),
    districtsFound () {
      return this.areas.districts !== undefined && this.areas.districts.length > 0
    }
  },
  created () {
    this.getAreas()
  },
  methods: {
    getAreas () {
      api.get('/aps/areas', {
        params: {
          officeId: this.selectedOffice.id
        }
      }).then(response => {
        this.areas = response.data
      })
    }
  },
  watch: {
    selectedOffice () {
      this.getAreas()
    }
  }
}
</script>

<style lang="scss" scoped>
.hover-trigger {
  .hover-content {
    position: absolute;
    top: 100%;
    right: -50px;
    width: 200px;
    z-index: 2;
    display: none;
  }

  &:hover {
    .hover-content {
      display: block;
    }
  }
}
</style>
